// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardPicker_root__2J6Nz","table":"DashboardPicker_table__n0Blj"};